export { InteractionHeader } from './InteractionHeader';
export type {
  InteractionHeaderProps,
  InteractionHeaderButtonProps,
} from './InteractionHeader';
